<template>
<div class="chapter">
<div class="inner_page">
<p class="bk-title"><span>The Mad Chopper</span></p>
<p class="bk-title1"><span><b>How the Justice System Let a Mutilator Free, This Time to Kill</b></span></p>
<p class="authorname"><span>Fred Rosen</span></p>
<p class="center" style="margin-top:80px;"><img alt="" src="images/logo.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?43ec2972